<template>
  <div v-if="visible" class="toast" :class="type">
    {{ message }}
  </div>
</template>

<script>
export default {
  name: 'ToastView',
  data() {
    return {
      visible: false,
      message: '',
      type: 'info'
    };
  }
};
</script>